import React from 'react';
import styled from 'styled-components';

export const SplitButton = ({ text, onClick }) => {
  return (
    <Container>
      <div className="split-button">
        <button onClick={(e) => onClick(e, true)}>
          <i className="fa fa-window-maximize" aria-hidden="true"></i>
          Same
        </button>
        <span className="label-gradient">{text}</span>
        <button onClick={(e) => onClick(e, false)} target="_blank">
          <i className="fa fa-window-restore" aria-hidden="true"></i>
          New
        </button>
      </div>
    </Container>
  );
};

export const Container = styled.div`
  .split-button {
    display: grid;
    grid-template-columns: 1fr 2.75fr 1fr;
    font-family: sans-serif;
    height: 40px;
    width: 100%;
    margin: 5px 0px;
  }

  button {
    cursor: pointer;
  }

  .split-button > button {
    border: solid 1px auto;
    margin: 0px 2px;
  }

  .split-button > button:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    color: white;
    background-color: #db2827;
    border: 1px solid #db2827;
  }

  .split-button > span {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #db2827;
    color: #000;
  }

  .split-button > button:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    color: white;
    background-color: #000;
    border: 1px solid #000;
  }

  .split-button > button > i {
    color: white;
    margin-right: 5px;
  }

  .label-gradient {
    background-image: linear-gradient(
      to right,
      #db2827 0%,
      #ffffff 50%,
      #000000 100%
    );
  }
`;
